import service from '@/store/services/communauties/forums-service';

const state = {
    list: [],
    forum: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, item) => {
        state.forum = item;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
};

const actions = {
    list({ commit, dispatch }, payload) {
        return service.list(payload)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((forum) => { commit('SET_RESOURCE', forum); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((forum) => { commit('SET_RESOURCE', forum); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((forum) => { commit('SET_RESOURCE', forum); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.total,
    forum: state => state.forum,
};

const forums = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default forums;